
import { defineComponent } from 'vue'
1
export default defineComponent({
    props: {
        stepsTitle: {
            required: true,
            type: Array,
            defalut() {
                return []
            }
        },
        active: {
            required: true,
            type: Number,
            default: 0
        }
    },
    setup() {}
})
